import { ICreateOrderResponse } from '../types/CreateOrder';

/**
 * Ссылка на оплату из ответа на создание заказа.
 *
 * Полей три, и заполнены они не всегда одновременно, поэтому берём первое
 * годное: `checkout_url` — сама страница оплаты, `short_link` — она же за
 * сокращателем, `paymentInfo` — запасной вариант.
 *
 * Схему проверяем не из паранойи: этот URL уходит прямо в `openLink`, а всё,
 * что не http(s), там либо не откроется, либо откроется не тем. Пустая строка
 * и голый домен без пути (`https://app.rhmt.uz/`) — это «платить не нужно»,
 * а не ссылка: наличными такой заказ просто оформляется дальше.
 */
export type PaymentLinkSource = Pick<
  ICreateOrderResponse,
  'checkout_url' | 'short_link' | 'paymentInfo'
>;

export const getPaymentUrl = (data?: PaymentLinkSource): string | null => {
  const candidates = [data?.checkout_url, data?.short_link, data?.paymentInfo];

  for (const candidate of candidates) {
    const url = candidate?.trim();
    if (!url) continue;

    try {
      const parsed = new URL(url);

      if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') continue;
      if (parsed.pathname === '/' && !parsed.search) continue;

      return url;
    } catch {
      // Не URL вовсе — пробуем следующее поле.
    }
  }

  return null;
};
